import { MdConstruction } from 'react-icons/md'

function PlaceholderPage({ title, description, icon }) {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="text-center py-12">
        <div className="w-24 h-24 bg-neutral-100 dark:bg-neutral-800 rounded-full flex items-center justify-center mx-auto mb-6">
          {icon || <MdConstruction className="text-4xl text-neutral-400 dark:text-neutral-500" />}
        </div>
        <h1 className="text-3xl font-bold text-neutral-900 dark:text-white mb-4">
          {title || 'Coming Soon'}
        </h1>
        <p className="text-lg text-neutral-600 dark:text-neutral-400 max-w-md mx-auto">
          {description || 'This feature is currently under development and will be available soon.'}
        </p>
      </div>
    </div>
  )
}

export default PlaceholderPage
